import promotionTypes from 'yola-editor/src/js/modules/upsell/constants/promotion-types';
import isDifmOfferBannerVisible from 'yola-editor/src/js/modules/upsell/helpers/is-difm-offer-banner-visible';
import isLimitedOfferAvailable from 'yola-editor/src/js/modules/upsell/helpers/is-limited-offer-available';

const getActivePromotions = ({
  upsellType,
  isNnDifmPromoFeatureFlagEnabled,
  isFreeTrialUpsellFeatureFlagEnabled,
  isFreeTrialAvailable,
}) => {
  const activePromotions = [];

  if (!isNnDifmPromoFeatureFlagEnabled && !isFreeTrialUpsellFeatureFlagEnabled) {
    return [promotionTypes.NOT_SET];
  }

  if (isFreeTrialAvailable) {
    activePromotions.push(promotionTypes.FREE_TRIAL);
  }

  const isLimitedOffer = isNnDifmPromoFeatureFlagEnabled && isLimitedOfferAvailable();
  const isVisibleDifmBanner = isLimitedOffer && isDifmOfferBannerVisible(upsellType);

  if (isVisibleDifmBanner) {
    activePromotions.push(promotionTypes.DIFM_BANNER);
  }

  if (isLimitedOffer) {
    activePromotions.push(promotionTypes.DIFM_BADGE);
  }

  if (activePromotions.length === 0) {
    activePromotions.push(promotionTypes.NOT_SET);
  }

  return activePromotions;
};

export default getActivePromotions;
